var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewVotedWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000166399 9.39358C0.00386068 9.23714 0.0692979 9.08852 0.182191 8.98017L4.16364 4.99872L0.182191 1.01727C0.0673137 0.905715 0.00248649 0.752412 0.00248012 0.592285C0.00253892 0.351141 0.14876 0.134097 0.372222 0.0434589C0.595684 -0.0471796 0.851786 0.00667767 1.01981 0.179645L5.42007 4.57991C5.65131 4.81124 5.65131 5.1862 5.42007 5.41753L1.01981 9.81779C0.850594 9.99409 0.590482 10.0484 0.364855 9.95453C0.139229 9.86066 -0.00560551 9.63788 0.000166399 9.39358Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewVotedWhite);
export default __webpack_public_path__ + "static/media/view_voted_white.4ca86527fdd7415922b71488e9645f35.svg";
export { ForwardRef as ReactComponent };